export default {
    methods: {
        onClickChildPaginate() {
            /* this event emited from Child */
            this.fetchData();
          },
    },
   
}